import { render, staticRenderFns } from "./ListingCapitalInvestment.vue?vue&type=template&id=2db2c881&"
import script from "./ListingCapitalInvestment.vue?vue&type=script&lang=js&"
export * from "./ListingCapitalInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports